// Recuperer les info de l'instance pour certains champs
const userInfo = JSON.parse(localStorage.getItem("user"));

// Nom du user pour remplir representative
const userName = `${userInfo?.firstname} ${userInfo?.lastname}`

// Nom de la compagnie
const company = `${userInfo?.company}`;

const emptyDataSuperblock = {
  id: null,
  UserId: null,
  companyName: company,
  productName: "Superblock",
  productId: "10",
  phoneNumber: null,
  quoteCode: null,
  projectNumber: null,
  quoteDate: null,
  isActive: true,
  quotationStatus: "Active",
  estimativeShippingDate: new Date(),
  unitaryPriceCDN: null,
  unitaryPriceUSD: null,
  unitsTag: null,
  numberUnits: 1,
  exchangeRate: null,
  shipping: "Not Included",
  representative: userName,
  stacked: "No",
  ///////////// CHAMPS PROPRE À Superblock /////////////
  airFlowEA: null,
  airFlowFA: null,
  arrangement: 'Side by Side',
  casingMaterial: 'Galvanized Steel',
  coreMaterial: null,
  corrugationHeight: null,
  depth: null,
  height: null,
  length: null,
  motorSide: 'Left',
  pressureDropSA: null,
  pressureDropRA: null,
  product: 'Superblock',
  voltage: '575/3',
  weight: null,
  width: null,
  ////////////////////////////////////////////////
  shipping: "Not Included",
  country: null,
  province: null,
  city: null,
  startUp: "Not Included",
  unitModel: "",            // champ le plus important, genere le reste du submittal
  selectionImportCode: "",
  mechanicalCode: null,
  margin: 0,
  leadTime: null,
  curbDrawing: null,
  electricalDiagram: null,
  unitaryPrice: null,
  unitaryShippingPrice: null,
  unitaryStartUpPrice: null,
  totalUnitaryPrice: null,
  isPriceValid: false,
  userCreation: null,
  dateCreation: new Date(),
  userModification: null,
  projectNumber: null,
  dateModification: new Date(),
  };

export default emptyDataSuperblock;

  
  